let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("40Okw")).then(() => parcelRequire('8L5CM'));